const THREE = require('three')
import * as ml from 'three.meshline'
import trackPath from '../../track-tiled/path'
import {svgToPath} from 'src/lib/transformSVGPath.js'
import raf from 'src/components/game/raf'
import * as STAGES from 'src/components/game/stages'
import {config as gameConfig} from 'src/components/game/config'
import {TimelineMax, TweenMax, Cubic} from 'gsap'
import _ from 'lodash'

import * as ui from '../scene'

let started = false
let opacity = {value : 0}

// *****************************************************************
//
// BG WHITE PATH
//
// *****************************************************************


let path = trackPath
let points = path.createPointsGeometry()

let meshLine = new ml.MeshLine()
meshLine.setGeometry( points )
let materialLine = new ml.MeshLineMaterial({
  lineWidth: 2,
  color: new THREE.Color(0xFFFFFF)
})

let meshPath = new THREE.Mesh( meshLine.geometry, materialLine )
meshPath.name = 'track mesh 1'

meshPath.geometry.drawRange.count = 0

// *****************************************************************
//
// RED PATH
//
// *****************************************************************

let meshLineRed = new ml.MeshLine()
meshLineRed.setGeometry( points )
let materialLineRed = new ml.MeshLineMaterial({
  lineWidth: 2,
  color: new THREE.Color(0xEB0033)
})

let meshPathRed = new THREE.Mesh( meshLineRed.geometry, materialLineRed )
meshPathRed.name = 'track mesh Red'
meshPathRed.geometry.drawRange.count = 0

// *****************************************************************
//
// PULSE ANIMATION
//
// *****************************************************************


let geometry = new THREE.SphereBufferGeometry( 36, 16, 16 )
let material = new THREE.MeshBasicMaterial( {color: 0xffffff, transparent: true} )
let sphere = new THREE.Mesh( geometry, material )
sphere.name = 'track point'
sphere.material.opacity = 0


// shader sphere effect, basic for now => https://codepen.io/dotgreg/pen/pwzoov
let Vs = `
  attribute vec3 position;
  attribute vec3 normal;

  uniform mat4 projectionMatrix;
  uniform mat4 modelViewMatrix;
  uniform float time;
  uniform float decal;

  varying float vPulse;

  void main () {

    float pulse = mod((time - decal * 250.0)/90.0, 1.0);
    vPulse = pulse;

    vec4 finalPosition = vec4(vec3(position + pulse * normal * 300.0 ), 1.0 + (0.2 * normal));
    gl_Position = projectionMatrix * modelViewMatrix * finalPosition;
  }
`
let Fs = `
  precision mediump float;

  varying float vPulse;

  void main() {
    gl_FragColor = vec4(1.0, 0, 0, 1.0) * (1.0 - vPulse);
  }
`
let materialPulse = new THREE.RawShaderMaterial({
  vertexShader: Vs,
  fragmentShader: Fs,
  uniforms: {
    time: { type: 'f', value: 0 },
    decal: { type: 'f', value: 0 }
  },
  shading: THREE.FlatShading,
  transparent: true
})

let geometryPulse = new THREE.SphereBufferGeometry( 0.001, 16, 16 )
let spherePulse = new THREE.Mesh( geometryPulse, materialPulse )

let spherePulse2 = spherePulse.clone()
spherePulse2.material = spherePulse.material.clone()
spherePulse2.material.uniforms.decal.value = 1

let spherePulse3 = spherePulse.clone()
spherePulse3.material = spherePulse.material.clone()
spherePulse3.material.uniforms.decal.value = 2


// *****************************************************************
//
// UPDATING MAP
//
// *****************************************************************


const update = _.throttle(()=> {
  if (!window.game) return false
  if (!started) return false

  const pt1 = path.getPointAt(window.game.state.progress.percent % 1)
  let percent = window.game.state.progress.percent % 1
  if (window.game.state.stage >= STAGES.RESULTS) percent = 0.999

  meshPathRed.geometry.drawRange.count = percent * (meshPathRed.geometry.attributes.counters.count * 3)
  sphere.position.set(pt1.x, pt1.y, pt1.z)

  // materialShader uniforms update
  spherePulse.material.uniforms.time.value ++
  spherePulse2.material.uniforms.time.value ++
  spherePulse3.material.uniforms.time.value ++
}, gameConfig.uiUpdateInterval)
// raf.on('tick', update)
setInterval(update, gameConfig.uiUpdateInterval)

// *****************************************************************
//
// Starting animation
//
// *****************************************************************


export let start = (seconds) => {
  started = true
  let tl = new TimelineMax({ onComplete: startPulse })
  tl.to(meshPath.geometry.drawRange, seconds, {count: meshPath.geometry.index.count, ease: Cubic.easeOut})
  tl.to(opacity, seconds, {value: 1, ease: Cubic.easeOut},`-=${seconds / 2}`)
}

export let reset = (seconds) => {
  started = false
  meshPath.geometry.drawRange.count = 0
  meshPathRed.geometry.drawRange.count = 0
  opacity.value = 0
  stopPulse()
}

let startPulse = () => {
  sphere.material.opacity = 1
  sphere.add(spherePulse)
  sphere.add(spherePulse2)
  sphere.add(spherePulse3)
}

let stopPulse = () => {
  sphere.material.opacity = 0
  sphere.children = []
}


// *****************************************************************
//
// WRAP
//
// *****************************************************************


export let mesh = new  THREE.Object3D()
mesh.name = 'dashboard-map'
mesh.scale.setScalar(0.04 / gameConfig.worldScale)
mesh.rotation.set(
  90 * THREE.Math.DEG2RAD,
  -90 * THREE.Math.DEG2RAD,
  0 * THREE.Math.DEG2RAD
)

mesh.add(meshPath)
mesh.add(meshPathRed)
mesh.add(sphere)

export default mesh



// WEBPACK FOOTER //
// ./src/components/game/ui/dashboard/map.js